import ai from './ai';
import alerts from './alerts';
import attribution from './attribution';
import brandAnalytics from './brand-analytics';
import brandStore from './brand-store';
import businessReports from './business-reports';
import catalog from './catalog';
import dashboard from './dashboard';
import dev from './dev';
import ebay from './ebay';
import finance from './finance';
import inventory from './inventory';
import listings from './listings';
import meta from './meta';
import orders from './orders';
import ppc from './ppc';
import settings from './settings';
import shopify from './shopify';
import walmart from './walmart';

// Marketplace-first sidebar. The Amazon wrapper is assembled here (not in the per-file
// arrays, which specs import directly). It carries no env/CASL gate of its own: it
// appears when either of its channels is connected, and each child group is gated by its
// own `channel` (see useConnectedChannels). eBay, Shopify, Walmart and Meta Ads are top-level marketplaces.
const amazon = {
  title: 'Amazon',
  channel: 'amazon',
  action: 'read',
  subject: 'User',
  icon: { icon: 'selfhst:amazon' },
  children: [
    ...ppc,
    ...attribution,
    ...brandAnalytics,
    ...brandStore,
    ...businessReports,
    ...listings,
    ...orders,
    ...inventory,
    ...finance,
  ],
};

export default [
  ...dashboard,
  ...ai,
  amazon,
  ...ebay,
  ...shopify,
  ...walmart,
  ...meta,
  ...catalog,
  ...settings,
  ...alerts,
  ...dev,
];
